module.exports = __webpack_public_path__ + "img/material-bg.894f29d1.png";